<div class="main-recover-password-company">  
    <div class="container">
        <div class="left-section">
            <h2>{{ 'companyCreatePassword.title' | translate }}</h2>
            <form [formGroup]="recoverPasswordForm" class="recover-password-form">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'companyCreatePassword.form.password' | translate }}</mat-label>
                    <input matInput type="password" id="password" formControlName="password" required>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'companyCreatePassword.form.confirmPassword' | translate }}</mat-label>
                    <input matInput type="password" id="confirmPassword" formControlName="confirmPassword" required>
                </mat-form-field>
                <div *ngIf="errorMessage" class="error-message">
                    {{ errorMessage }}
                </div>
                <div *ngIf="confirmPasswordMessage" class="confirm-password-message">
                    {{ confirmPasswordMessage }}
                </div>
                <ng-container *ngIf="!isLoading && !changed">
                    <button mat-raised-button color="primary" type="button" (click)="onSubmit()">
                        {{ 'companyCreatePassword.form.createPassword' | translate }}
                    </button>
                </ng-container>
                <ng-container *ngIf="isLoading">
                    <img src="/assets/spinner.gif" [alt]="'companyCreatePassword.form.loading' | translate" class="loading-gif">
                </ng-container>
                <ng-container *ngIf="changed">
                    <button mat-raised-button color="primary" type="button" (click)="navigateToLogin()">
                        {{ 'companyCreatePassword.form.goToLogin' | translate }}
                    </button>
                </ng-container>
            </form>
        </div>
    </div>
</div>